import type { ComponentType, Dispatch, SetStateAction } from 'react'

import { MultiSelectFilter } from './MultiSelectFilter'
import type { AnyFilterComponentProps, FilterOptionsHook } from './types'

export function createLazyFilterComponent(
  useOptions: FilterOptionsHook,
): ComponentType<AnyFilterComponentProps> {
  return ({ name, value, setQueryString }) => (
    <LazyMultiSelectFilter
      name={name}
      value={value as string[]}
      setQueryString={setQueryString}
      useOptions={useOptions}
    />
  )
}

export type SubFilterProps = {
  name: string
  value: string[]
  setQueryString: Dispatch<SetStateAction<string>>
}

type Props = SubFilterProps & {
  useOptions: FilterOptionsHook
}

export function LazyMultiSelectFilter({
  name,
  value,
  setQueryString,
  useOptions,
}: Props) {
  const { options, isLoading } = useOptions(true)

  return (
    <MultiSelectFilter
      name={name}
      options={options}
      value={value}
      setQueryString={setQueryString}
      isLoading={isLoading}
    />
  )
}
